export default __webpack_public_path__ + "static/media/industrialModuleImage.f8d36a26.svg";